export const AdSetTargetingUpdatedIcon = ({ className, size = 27, ...props }) => (
    <svg
        {...props}
        width={size}
        height={size}
        viewBox="0 0 27 27"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <mask id="path-3-inside-1_6068_57067" fill="white">
            <rect x="0.333984" y="6.33398" width="5.92593" height="5.92593" rx="0.888889"/>
        </mask>
        <rect x="0.333984" y="6.33398" width="5.92593" height="5.92593" rx="0.888889" stroke="#899CBD" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" mask="url(#path-3-inside-1_6068_57067)"/>
        <mask id="path-4-inside-2_6068_57067" fill="white">
            <rect x="7.74023" y="6.33398" width="5.92593" height="5.92593" rx="0.888889"/>
        </mask>
        <rect x="7.74023" y="6.33398" width="5.92593" height="5.92593" rx="0.888889" stroke="#899CBD" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" mask="url(#path-4-inside-2_6068_57067)"/>
        <mask id="path-5-inside-3_6068_57067" fill="white">
            <rect x="7.74023" y="13.7402" width="5.92593" height="5.92593" rx="0.888889"/>
        </mask>
        <rect x="7.74023" y="13.7402" width="5.92593" height="5.92593" rx="0.888889" stroke="#899CBD" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" mask="url(#path-5-inside-3_6068_57067)"/>
        <mask id="path-6-inside-4_6068_57067" fill="white">
            <rect x="0.333984" y="13.7402" width="5.92593" height="5.92593" rx="0.888889"/>
        </mask>
        <rect x="0.333984" y="13.7402" width="5.92593" height="5.92593" rx="0.888889" stroke="#899CBD" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" mask="url(#path-6-inside-4_6068_57067)"/>
        <path d="M20.5264 2.41797C20.8209 2.17766 21.2557 2.19512 21.5303 2.46973L22.5303 3.46973C22.8232 3.76262 22.8232 4.23738 22.5303 4.53027L18.7803 8.28027C18.6757 8.38488 18.5425 8.45627 18.3975 8.48535L17.1475 8.73535C16.9016 8.78453 16.647 8.70759 16.4697 8.53027C16.2924 8.35296 16.2155 8.09843 16.2646 7.85254L16.5146 6.60254C16.5437 6.45749 16.6151 6.32434 16.7197 6.21973L20.4697 2.46973L20.5264 2.41797Z" stroke="#899CBD" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export default AdSetTargetingUpdatedIcon